import { render } from "./ChangePassword.vue?vue&type=template&id=2a16198e"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=2a16198e&lang=css"
script.render = render

export default script